import React from 'react';
import { Flex, VStack, HStack, Box, Skeleton, Separator } from '@skin-seoul/design-system';

export const OrderCardSkeleton = () => {
  return (
    <VStack
      width="100%"
      bg="generic.0"
      border="1px solid"
      borderColor="neutral.100"
      borderRadius="8px"
      overflow="hidden"
      gap={0}
    >
      <VStack gap={3} padding={3} width="100%" alignItems="flex-start">
        <Flex justifyContent="space-between" alignItems="flex-end" width="100%">
          <VStack gap={1} alignItems="flex-start">
            <HStack gap={2}>
              <Skeleton width="8px" height="8px" borderRadius="50%" />
              <Skeleton height="20px" width="100px" />
            </HStack>
            <Skeleton height="14px" width="150px" />
          </VStack>
          <Skeleton height="14px" width="60px" />
        </Flex>

        <Flex
          bg="primary.50"
          border="1px solid"
          borderColor="primary.100"
          borderRadius="8px"
          padding={3}
          justifyContent="space-between"
          width="100%"
        >
          <VStack gap={1} alignItems="flex-start" flex="1">
            <Skeleton height="14px" width="100px" />
            <HStack gap={1}>
              <Skeleton height="16px" width="80px" />
              <Skeleton width="16px" height="16px" />
            </HStack>
          </VStack>
          <VStack gap={1} alignItems="flex-end">
            <Skeleton height="14px" width="40px" />
            <Skeleton height="16px" width="60px" />
          </VStack>
        </Flex>

        <HStack gap={3} width="100%">
          <Box
            width="72px"
            height="72px"
            border="1px solid"
            borderColor="neutral.50"
            borderRadius="8px"
            overflow="hidden"
            flexShrink={0}
          >
            <Skeleton width="100%" height="100%" />
          </Box>

          <VStack gap={3} flex="1" alignItems="flex-start">
            <VStack gap={1} width="100%" alignItems="flex-start">
              <Skeleton height="14px" width="70%" />
              <HStack justifyContent="space-between" width="100%">
                <HStack gap={1}>
                  <Skeleton height="12px" width="60px" />
                  <Skeleton height="12px" width="40px" />
                </HStack>
                <Skeleton height="12px" width="50px" />
              </HStack>
            </VStack>
            <Skeleton height="28px" width="120px" borderRadius="4px" />
          </VStack>
        </HStack>

        <VStack gap={2} width="100%">
          <Separator width="100%" />
          <HStack justifyContent="space-between" width="100%">
            <VStack gap={1} alignItems="flex-start">
              <Skeleton height="12px" width="100px" />
              <Skeleton height="16px" width="140px" />
            </VStack>
            <VStack gap={1} alignItems="flex-start">
              <Skeleton height="12px" width="100px" />
              <HStack gap={1}>
                <Skeleton height="16px" width="120px" />
                <Skeleton width="16px" height="16px" />
              </HStack>
            </VStack>
          </HStack>
          <HStack justifyContent="space-between" width="100%">
            <Skeleton height="16px" width="100px" />
            <Skeleton width="20px" height="20px" borderRadius="50%" />
          </HStack>
        </VStack>
      </VStack>
    </VStack>
  );
};

